import { CascadiaColor, CascadiaTypographyStyle } from "@certn/cascadia-tokens";
import { LabelAlign } from "../../types";

export function getInnerContentTextStyles(
  labelAlign?: LabelAlign,
  overrideTextStyle?: CascadiaTypographyStyle,
  overrideTextColor?: CascadiaColor
) {
  type TextStyles = { style: CascadiaTypographyStyle; color: CascadiaColor };
  const textStyles: Record<
    NonNullable<LabelAlign>,
    { label: TextStyles; value: TextStyles }
  > = {
    vertical: {
      label: {
        style: "summary/content-secondary",
        color: "text-weak",
      },
      value: {
        style: overrideTextStyle || "summary/content-primary",
        color: overrideTextColor || "text-base",
      },
    },
    horizontal: {
      label: {
        style: "global/heading-medium",
        color: "text-base",
      },
      value: {
        style: "global/body-primary",
        color: "text-weak",
      },
    },
  };
  return textStyles[labelAlign || "vertical"];
}
